import { useState } from "react";
import { IoChevronDown } from "react-icons/io5";

const AccordionItem = ({ title, children, isOpen, onToggle }) => {
    return (
        <div className="accordion-item">
            <button className="accordion-header" onClick={onToggle}>
                <span>{title}</span>
                <span className={`accordion-icon-wrapper ${isOpen ? 'open' : ''}`}>
                    <IoChevronDown />
                </span>
            </button>
            {isOpen && <div className="accordion-content">{children}</div>}
        </div>
    );
};

const FaqComponent = ({ onClose }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqData = [
        {
            question: "What's next?",
            answer: "Once you complete your booking, you'll receive a confirmation email with all the details of your first service appointment. Our team will handle the rest!"
        },
        {
            question: "When will I be billed?",
            answer: "You will be billed automatically after each service is completed using the payment method you provide during checkout."
        },
        {
            question: "Who will be servicing my pool?",
            answer: "Your pool will be serviced by one of our CPO-certified, background-checked, and fully insured professional technicians."
        },
        {
            question: "How did you come up with my quote?",
            answer: "Our quotes are based on your pool's size, equipment, and the specific services you've selected. We aim for transparent and fair pricing."
        },
        {
            question: "Why do I need my pool filters cleaned?",
            answer: "Regular filter cleaning is essential for maintaining clear, safe water and ensuring your pool equipment runs efficiently, which can save you money on energy costs."
        },
        {
            question: "I still have questions. Can I talk to someone?",
            answer: "Absolutely! Our support team is available 7 days a week. You can call us, email us, or use the live chat feature on our website."
        },
    ];

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="faq-container">
            <h2 className="faq-title">Frequently Asked Questions</h2>
            <div className="accordion-container">
                {faqData.map((item, index) => (
                    <AccordionItem key={index} title={item.question} isOpen={index === openIndex} onToggle={() => handleToggle(index)}>
                        {item.answer}
                    </AccordionItem>
                ))}
            </div>
            <button className="continue-button" onClick={onClose}>CONTINUE TO BOOKING</button>
        </div>
    );
};

export default FaqComponent;